/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {SettlementStatusEnum} from './settlement-status.enum';

export class SettlementStatusEnumMapper {
    private constructor() {
    }

    static fromString(input: string): SettlementStatusEnum {
        let userType = SettlementStatusEnum.UNKNOWN;

        if (Object.values(SettlementStatusEnum)
                .includes(input as SettlementStatusEnum)) {
            userType = input as SettlementStatusEnum;
        }

        return userType;
    }

    static toString(input: SettlementStatusEnum): string {
        return input ?? '';
    }
}
